/*  React  */
import { CellContext } from '@tanstack/react-table';
import React from 'react';

import { HMS } from '../Usage';

/**
 * A React component that renders a Hours/Minutes/Seconds value (01:02:03) in a table cell.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.column - The column object.
 * @param {Object} props.column.columnDef - The column definition object.
 * @param {string} props.column.columnDef.accessorKey - The key to access the value in the row object.
 * @param {string} [props.column.columnDef.defaultKey] - The translation key for the default value.
 * @param {Object} props.cell - The cell object containing the data.
 *
 * @returns {React.ReactElement} The rendered table cell component.
 */
export const HMSCell = <TData,>({
    cell
}: CellContext<TData, unknown>): React.ReactElement => {
    const value = cell.getValue() as number;
    return <HMS seconds={value} />;
};
